import React, {useContext} from 'react';
import {Avatar, Button, Card, CardActionArea, CardContent, CardHeader, Chip, Divider, Tooltip} from "@mui/material";
import Typography from "@mui/material/Typography";
import {getDataLabel} from "../../../../utils/TableUtils";
import {amber, green, purple, red} from "@mui/material/colors";
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {useTheme} from "@mui/styles";
import {AppContext} from "../../../../App";
import {capitalizeWords} from "../../../../utils/GenericUtils";

const IntervistaCompletaCard = ({intervista}) => {
	const theme = useTheme();
	const appContext = useContext(AppContext);
	
	return (
        <React.Fragment>
            <Tooltip
				title={"Clicca per gestire: intervistare o lasciarla incompleta in caso il paziente non sia disponibile"}>
				<CardActionArea onClick={() => console.log("Hey man...")}>
					<CardHeader
						style={{paddingBottom: 2}}
						avatar={
							<Avatar>
								<SVG src={multiavatar(intervista?.soggetto?.codF)}/>
							</Avatar>
						}
						title={
							<React.Fragment>
								<Typography variant={"subtitle1"} style={{position: "relative"}}>
									<b>Intervista paziente <span
										style={{color: theme.palette.primary.main}}>{intervista.tipoContatto && intervista.tipoContatto}</span></b>
									{
										intervista.focolaioId === null &&
										<Chip style={{
											color: "#FFF",
											backgroundColor: purple[800],
											paddingLeft: 2,
											paddingRight: 2,
											position: "absolute",
											right: 1
										}} label={"SENZA ORDINANZA"}/>
									}
								</Typography>
							</React.Fragment>
						}
						subheader={<Typography variant={"body2"} color={"textSecondary"}>
							Ultima modifica: <b>{getDataLabel(intervista.dataUltimaModifica)}</b> da parte
							di <b>{intervista.lastModify}</b>
						</Typography>}
					/>
					<CardContent style={{paddingTop: 8}}>
						<div style={{display: "flex"}}>
							<Tooltip title={"Clicca per copiare"}>
								<Button variant={"text"}
								        style={{padding: 2, color: theme.palette.text.secondary, textTransform: "none"}}
								        component={"div"}
								        onClick={(event) => {
									        event.stopPropagation();
									        navigator?.clipboard?.writeText(intervista.id).then(() => {
										        setOpenSnackbar("info", "ID copiato negli appunti", appContext.dispatch);
									        })
								        }}>
									<b>{"ID: " + intervista.id}</b>
								</Button>
							</Tooltip>
							<Divider orientation={"vertical"}
							         style={{height: 16, marginLeft: 10, marginRight: 10, alignSelf: "center"}}/>
							<Tooltip title={"Clicca per copiare"}>
								<Button variant={"text"}
								        style={{padding: 2, color: theme.palette.text.secondary, textTransform: "none"}}
								        component={"div"}
								        onClick={(event) => {
									        event.stopPropagation();
									        navigator?.clipboard?.writeText(intervista.soggetto?.codF).then(() => {
										        setOpenSnackbar("info", "Codice fiscale copiato negli appunti", appContext.dispatch);
									        })
								        }}>
									{
										intervista.soggetto?.codF === "UTENTE_ANONIMO" ? <b>Utente anonimo</b> :
											<b>{"Codice fiscale : " + intervista.soggetto?.codF + ", " + capitalizeWords(intervista.soggetto?.nome) + " " + capitalizeWords(intervista.soggetto?.cognome)}</b>
									}
								</Button>
							</Tooltip>
						</div>
						<Typography variant={"body2"} color={"textSecondary"} component={"div"}>
							{intervista.note ? (intervista.note.includes("[{\"tipoDocumento\":") ?
								JSON.parse(
									intervista.note
										.replaceAll("#COMPILATA_CITTADINO ", "")
										.replaceAll("null", "")
										.replaceAll(/#(\S*)/g, "")
								)?.map((contatto, index) => {
									return (<Card key={index} variant={"outlined"} style={{marginTop: 4, borderRadius: 24}}>
										<CardHeader title={
											<Typography variant={"subtitle1"}>
												<b>{contatto?.nome + " " + contatto?.cognome}</b><br/>
												email: {contatto?.email}<br/>
												cell : {contatto?.cell}<br/>
												codice fiscale: {contatto?.codiceFiscale ? contatto?.codiceFiscale : "--"}
											</Typography>
										}/>
									</Card>)
								}) :
								intervista.note) : "Non sono presenti note"}
						</Typography>
						{
							intervista?.listaSintomi?.length > 0 && intervista?.listaSintomi?.split(",")?.map(tag => {
								return (
									<Chip
										key={tag}
										label={tag}
										avatar={<Avatar style={{backgroundColor: red[700], color: "#FFF"}}><b>#</b></Avatar>}
										color={"default"}
										style={{
											marginRight: 8,
											marginTop: 8,
											color: "#FFF",
											backgroundColor: red[400]
										}}/>
								)
							})
						}
						{
							intervista?.listaPatologieCroniche?.length > 0 && intervista?.listaPatologieCroniche?.split(",")?.map(tag => {
								return (
									<Chip
										key={tag}
										label={tag}
										avatar={<Avatar style={{backgroundColor: green[700], color: "#FFF"}}><b>#</b></Avatar>}
										color={"default"}
										style={{
											marginRight: 8,
											marginTop: 8,
											color: "#FFF",
											backgroundColor: green[400]
										}}/>
								)
							})
						}
						{
							intervista?.listaImmunodepressioni?.length > 0 && intervista?.listaImmunodepressioni?.split(",")?.map(tag => {
								return (
									<Chip
										key={tag}
										label={tag}
										avatar={<Avatar style={{backgroundColor: amber[700], color: "#FFF"}}><b>#</b></Avatar>}
										color={"default"}
										style={{
											marginRight: 8,
											marginTop: 8,
											color: "#000",
											backgroundColor: amber[400]
										}}/>
								)
							})
						}
						{
							intervista?.listaEspRischio?.length > 0 && intervista?.listaEspRischio?.split(",")?.map(tag => {
								return (
									<Chip
										key={tag}
										label={tag}
										avatar={<Avatar style={{backgroundColor: purple[700], color: "#FFF"}}><b>#</b></Avatar>}
										color={"default"}
										style={{
											marginRight: 8,
											marginTop: 8,
											color: "#FFF",
											backgroundColor: purple[400]
										}}/>
								)
							})
						}
					</CardContent>
				</CardActionArea>
			</Tooltip>
        </React.Fragment>
    );
};

export default React.memo(IntervistaCompletaCard)
